export const BASIC_STYLES_UPLOADER_PREFIX = 'basic-styles-uploader'
export const BRAND_START_ORDER_MODAL = 'brand-start-order'
export const CHANGE_SALES_REP_MODAL = 'change-sales-rep-modal'
export const CUSTOM_PROFILE = 'custom-profile'
export const FIND_NEW_BRANDS_PREFIX = 'find-new-brands'
export const DOWNLOAD_ORDER_CONFIRMATION = 'Download-Order-Confirmation'
export const EARLY_ACCESS_PREFIX = 'early-access'
export const EXPORT_DATA = 'Export-Data-Modal'
export const EXTERNAL_PAYMENTS = 'external-payments'
export const FIND_NEW_RETAILERS_PREFIX = 'find-new-retailers'
export const PROSPECTS_PREFIX = 'prospects'
export const HOME_DASHBOARD_PREFIX = 'home-dashboard'
export const IMPORT_ORDERS_PREFIX = 'import-orders'
export const JOOR_PAY_ORDERS_PREFIX = 'joor-pay-orders'
export const LIST_LINESHEETS_PREFIX = 'list-linesheets'
export const MANAGE_IMAGES_MODAL = 'manage-images-modal'
export const MANAGE_LOOKS_PREFIX = 'manage_looks'
export const MANAGE_STYLEBOARDS = 'manage-styleboards'
export const MANAGE_STYLES_PREFIX = 'manage-styles'
export const MOVE_PRODUCTS_PREFIX = 'move-products'
export const NAVBAR_REVAMP_PREFIX = 'navbar-revamp'
export const ORDER_LIST_PREFIX = 'order-list'
export const ORDER_REVIEW = 'order-review'
export const PAYMENT_SETTINGS_PREFIX = 'payment-settings'
export const PERMISSION_SETTINGS_PREFIX = 'permission-settings'
export const PRODUCT_CATALOG = 'catalog'
export const REASSIGN_CONNECTIONS_MODAL = 'reassign-connections-modal'
export const REPORTS = 'reports'
export const RETAILER_PROFILE_PREFIX = 'retailer-profile'
export const RETAILER_START_ORDER_MODAL = 'retailer-start-order'
export const SUBMISSIONS_PREFIX = 'submissions'
export const UPLOAD_EXCEL_ORDER_MODAL = 'upload-excel-order'
export const CANCEL_REPLACE_STYLE = 'cancel-replace-style'
export const ADD_CONNECTIONS_MODAL = 'add-connections-modal'
export const LITE_RETAILER_CENTER = 'lite-retailer-center'
export const SWATCH_MANAGEMENT = 'swatch-management'
export const BULK_IMAGE_UPLOADER = 'bulk-image-uploader'
export const SHOPIFY_INTEGRATION = 'shopify-integration'
export const VISUAL_ASSORTMENT = 'visual-assortment'
export const USER_MANAGEMENT = 'user-management'
export const DATA_ACTIVITY_CENTER_PREFIX = 'data-activity-center'
